import React, { useState, useEffect } from 'react';
import shortid from 'shortid';
import { IoIosArrowRoundForward } from 'react-icons/io';
import { MdLocationOn } from "react-icons/md"
import { FaUserFriends } from "react-icons/fa"
import { FiClock } from "react-icons/fi"

const WorkPosition = () => {
  const [offerts, setOfferts] = useState([]);

  useEffect(() => {
    fetch('https://ulamlabs.recruitee.com/api/offers')
      .then(resp => resp.json())
      .then(data => {
        setOfferts(data.offers);
      });
  }, []);

  const toHumanReadable = employmentType => {
    if (employmentType === 'fulltime') return 'Full-Time';
    if (employmentType === 'parttime') return 'Part-time';
    return employmentType;
  };

  const result = offerts.map(offert => (
    <a
      href={offert.careers_url}
      className="col-lg-6 col-md-12"
      target="_blank"
      rel="noopener noreferrer"
      key={shortid.generate()}
    >
      <div className="work">
        <div className="position">{offert.title}</div>
        <div className="work-details">
          <div className="description">
            <MdLocationOn />
            <span className="position-field">
              {`${
                offert.remote
                  ? `${offert.city}, ${offert.country_code} (remote working possible)`
                  : `${offert.city}, ${offert.country_code}`
                }`}
            </span>
          </div>
          <div className="worktime">
            <FiClock />
            <span className="position-field">
              {toHumanReadable(offert.employment_type_code)}
            </span>
          </div>
          <div className="department">
            <FaUserFriends />
            <span className="position-field">{offert.department}</span>
          </div>
        </div>
        <div className="read-more">
          Apply <IoIosArrowRoundForward />
        </div>
      </div>
    </a>
  ));

  return result;
};

export default WorkPosition;
